module.exports = __webpack_public_path__ + "static/media/21.cc36f228.png";